
import { Component, Prop, Vue ,Model ,Watch } from "vue-property-decorator";
import { imgHost } from '@/utils/config';

@Component({
    name: 'step-component',
})
export default class StepComponent extends Vue {
  @Prop({default:false}) show!: boolean;
  @Prop({default:'image'}) private fileType!: any;
  @Prop({default:()=>{return []}}) private previewlist!: any;
  @Prop() private currentUrl!: any;
  private src = ''
  private IsShow = false;
	private imgHost = imgHost
  private index = -1
  @Watch('show',{immediate:true}) 
  private changeshow (val:boolean){
    // console.log(val)
    this.IsShow = val
    if(val){
      this.src = this.currentUrl
      if(this.previewlist&&this.previewlist.length){
        this.index = this.previewlist.indexOf(this.currentUrl)
      }

    }
    // console.log(this.currentUrl,this.previewlist,this.index)
  }

  private toleft(){
    if(this.index<=0){
      this.index = this.previewlist.length-1
      this.src = this.previewlist[this.index]
      return 
    }
    this.index--
    this.src = this.previewlist[this.index]
  }
  private toright(){
    if(this.index>=this.previewlist.length-1){
      this.index = 0
      this.src = this.previewlist[this.index]
      return 
    }
    this.index++
    this.src = this.previewlist[this.index]
  }




  private created () {
    // this.$nextTick(()=>{
    //   const body = document.querySelector('body')
    //   body.appendChild(this.$el)
    // })
  }
  private close(){
    this.IsShow = false
    this.$emit('close')
  }
}
